<h1 *scText="loginWith.token.title" class="login-title"></h1>

	<ng-container *ngIf="userBlockedError">
		<div class="alert label-login-qr alert-danger">
			{{ formFields.genericErrors.userBlocked.message }}
		</div>
	</ng-container>

	<ng-container *ngIf="invalidCredentialsError">
		<div class="alert label-login-qr alert-danger">
			{{ formFields.genericErrors.userFailed.message }}
		</div>
	</ng-container> 

	<div class="login-container">
		<div class="form-container">
			<ng-container>
				<form [formGroup]="loginForm" (submit)="submitAction()">
					<div class="label-login-qr">
						<label class="login" for="safeName">
							{{ formFields.fields.username.label.value }}
						</label>
						<input class="form-control" [placeholder]="formFields.fields.username.placeholder"
							formControlName="username" #usernameInput [maxlength]="formFields.genericErrors.length.parameter" />
						<span class="field-validation-error" *ngIf="username.errors?.required">{{
							formFields.genericErrors.usernameRequired.message }}</span>
					</div>

					<div class="label-login-qr">
						<label class="login" for="logincode" *scText="formFields.fields.logincode.label"></label>
						<input class="form-control" [placeholder]="formFields.fields.logincode.placeholder"
							formControlName="logincode" #passwordInput [maxlength]="formFields.genericErrors.length.parameter" />
						<span class="field-validation-error" *ngIf="logincode.errors?.required">{{
							formFields.genericErrors.required.message }}</span>
					</div>

					<div class="form-group label-login-qr">
						<ng-container>
							<button class="btn btn-primary btn-step w-100" [disabled]="loginForm.invalid || isLoading" abButtonLoader
								[ngClass]="{ 'btn-loader': isLoading }">
								<span *scRichText="submitButtonText"></span>
							</button>
						</ng-container>
					</div>
				</form>
			</ng-container>

			<ng-container>
				<button class="btn btn-outline-primary btn-step w-100" (click)="loginWithApp.emit()">
					<span>Continue with your mobile app</span>
				</button>
			</ng-container>
		</div>
		<div class="helpsteps-container">
			<ul class="tabbable-nav">
				<li (click)="selectActiveTab('token')" [ngClass]="{active: helpMethod === 'token'}">
					<span>Aruba Bank Token</span>
				</li>
				<li (click)="selectActiveTab('app')" [ngClass]="{active: helpMethod === 'app'}">
					<span>ARUBA BANK APP</span>
				</li>
			</ul>
			<ng-container *ngIf="helpMethod === 'token'">
				<div class="list-numbered">
					<ul class="list-numbered fixed-view order-steps-list-qr">
						<ng-container *ngIf="items && items.tokenHelpSteps">
							<li *ngFor="let item of items.tokenHelpSteps.fields.items; let i = index">
								<div>
									<div class="circle blue steps">
										<span *scText="item.fields.stepNumber"></span>
									</div>
								</div>
								<div>
									<p class="fs-18" *scRichText="item.fields.stepText"></p>
								</div>
							</li>
						</ng-container>
					</ul>
				</div>
			</ng-container>
		</div> 
	</div>